
<div>
  <b-row>
    <b-col cols="4" style="height: 85vh !important; overflow-y: auto">
      <h3 class="float-left">Dina listor</h3>
      <div v-if="!tester">
        <b-button
          size="sm"
          class="float-right"
          variant="primary"
          @click="addList"
        >
          Lägg till lista
        </b-button>
      </div>
      <b-table
        fixed
        no-local-sorting
        hover
        :items="standardLists"
        :fields="standardlistFields"
        @row-clicked="
          (item) => {
            viewList(item)
          }
        "
      >
        <template #cell(name)="data">
          <span
            :class="[
              viewedList.id == data.item.id ? 'active_row' : '',
              'onHover',
            ]"
            >{{ data.item.name }}</span
          >
        </template>
        <template #cell(counter)="data">
          <span class="pl-3">{{ data.item.counter }}</span>
        </template>
        <template #cell(checkbox)="data">
          <kbd>CTRL+{{ data.index + 1 }}</kbd>
          <b-form-radio
            v-model="selectedStandard"
            class="float-right"
            :value="data.item.id"
            @change="selectTarget(data.item)"
          />
        </template>
      </b-table>
      <b-table
        fixed
        hover
        :items="orderedAddonLists"
        :fields="addonlistFields"
        @row-clicked="
          (item) => {
            viewList(item)
          }
        "
      >
        <template #cell(name)="data">
          <span
            :class="[
              viewedList.id == data.item.id ? 'active_row' : '',
              'onHover',
            ]"
            >{{ data.item.name }}</span
          >
        </template>
        <template #cell(counter)="data">
          <span class="pl-3">{{ data.item.counter }}</span>
        </template>
        <template #cell(checkbox)="data">
          <kbd v-if="selectedAddons.indexOf(data.item.id) != -1">{{
            data.index + 1
          }}</kbd>
          <b-form-checkbox
            :id="data.item.id + '_' + data.index"
            :key="data.item.id"
            v-model="selectedAddons"
            class="float-right"
            :value="data.item.id"
          />
        </template>
      </b-table>
    </b-col>
    <b-col>
      <b-overlay :show="loading">
        <!--   <b-tabs v-model="tabIndex" pill contentClass="mt-3" @input="changeTab">
        <b-tab v-for="l in lists" :title="l.name" :key="'dyn-list' + l.id"> -->
        <b-row>
          <b-col>
            <div class="float-left">
              <h2 class="mb-0">
                {{ viewedList.name }}
              </h2>
              <div v-if="!tester">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  class="m1-0 mb-1 text-right"
                  @click="editList()"
                >
                  Byt namn/typ
                </b-button>
                <b-button
                  v-if="!viewedList.temp"
                  type="submit"
                  size="sm"
                  variant="danger"
                  class="ml-0 mb-1 text-right"
                  @click="removeList()"
                >
                  Ta bort lista
                  <b-icon-trash />
                </b-button>
              </div>
            </div>
            <div class="float-right">
              <b-form-input
                v-model="filter"
                size="sm"
                placeholder="Sök på förkortning eller fras..."
                filter-debounce="200"
              />
              <b-form-input
                v-model="currentPage"
                style="max-width: 55px"
                class="float-left"
                size="sm"
              /><b-pagination
                v-model="currentPage"
                size="sm"
                class="float-right"
                :total-rows="paginationRows"
                :per-page="perPage"
                aria-controls="abbs"
              />
            </div>
          </b-col>
        </b-row>
        <div
          style="height: 75vh !important; overflow-y: auto"
          @scroll="onScrollAbbs"
        >
          <b-table
            id="abbs"
            striped
            hover
            small
            responsive
            :items="abbProvider"
            :fields="abbFields"
            primary-key="id"
            :filter="filter"
            :filter-function="searchAbb"
            :per-page="perPage"
            :current-page="currentPage"
            no-local-sorting
            :sort-by="sortBy"
            sort-desc
            @sort-changed="sortChanged"
          >
            <template #cell(abb)="row">
              <div>
                {{ row.item.abb }}
              </div>
            </template>
            <template #cell(word)="row">
              <template v-if="editing != row.item.id">
                <div
                  style="
                    word-wrap: break-word;
                    min-width: 220px;
                    white-space: normal;
                  "
                  @click="editAbb(row.item)"
                >
                  {{ row.item.word }}
                </div>
              </template>
              <b-form-input
                v-else
                v-model="row.item.word"
                @change="onUpdateAbb(row.item, viewedList.id)"
              />
              <!--     <div @click="editAbb(row.item)" v-else style="word-wrap: break-word;min-width: 240px;max-width: 240px;white-space:normal;">{{ row.item.word }}</div>
      -->
            </template>
            <template #cell(updated)="row">
              <div
                v-if="viewedList.id != 'temp'"
                class=""
                style="min-width: 60px"
              >
                {{ row.item.updated | formatDate }}
              </div>
            </template>
            <template v-if="viewedList.type < 2" #cell(remove)="row">
              <!-- <b-button
            v-model="row.item.commend"
            type="submit"
            size="md"
            class="mt-0"
            variant="primary"
            @click="commendAbb(row.item, viewedList.id)"
          >
            <b-icon-arrow-up />
          </b-button>-->
              <b-button
                v-model="row.item.remove"
                type="submit"
                size="sm"
                variant="danger"
                class="mt-0"
                @click="removeAbb(row.item, viewedList.id)"
              >
                <b-icon-trash />
              </b-button>
            </template>
          </b-table>
        </div>
        <!--        <b-row>
        <b-col class="text-right"> </b-col>
      </b-row>
      -->
      </b-overlay>
    </b-col>
  </b-row>
  <AddList />
  <RemoveList :list="viewedList" :abbs="abbs" />
  <EditList :list="viewedList" />
</div>
